'use client';

import Typography from '@ui/Typography';
import React, { useEffect, useMemo, useState } from 'react';
import JoinFormFinalStep from './JoinFormFinalStep';
import JoinFormLocationStep from './JoinFormLocationStep';
import JoinFormProfileStep from './JoinFormProfileStep';
import { useUser } from '@auth0/nextjs-auth0/client';

function GuestJoinNonProfitForm(props) {
  const { user, handleFormData, nonProfit } = props;
  const auth0Session = useUser();
  const auth0User = auth0Session.user || user;

  console.log('GuestJoinNonProfitForm', auth0User);

  const [step, setStep] = useState('profile');
  const [formData, setFormData] = useState({
    email: auth0User?.email || '',
    firstName: auth0User?.given_name || auth0User?.nickname || '',
    lastName: auth0User?.family_name || '',
    auth0_id: auth0User?.sub || '',
  });

  console.log('formData', formData);

  const initialUserData = useMemo(
    () => ({
        email: auth0User?.email || '',
        firstName: auth0User?.given_name || auth0User?.nickname || '',
        lastName: auth0User?.family_name || '',
        auth0_id: auth0User?.sub || '',
    }),
    [auth0User],
  );

  useEffect(() => {
    setFormData(initialUserData);
  }, [initialUserData])

  const submitApplication = async (data) => {
    const {
      avatar,
      country,
      birthYear,
      birthMonth,
      jobTitle,
      company,
      auth0_id,
      ...rest
    } = data;
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...rest,
        auth0_id: auth0_id || auth0User?.sub,
        designation: jobTitle,
        companyName: company,
        country: country.id,
        dob: new Date(birthYear.value, birthMonth.value, 1).toISOString(),
        t_and_c_timestamp: new Date().toISOString(),
      }),
    );
    if (avatar) {
      formData.append('avatar', avatar);
    }

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/non-profits/${nonProfit.id}/apply`,
      {
        method: 'POST',
        body: formData,
      },
    );

    if (res?.ok) {
      setStep('success');
    } else {
      if (res?.status === 409) {
        setStep('error');
      } else {
        setStep('backend-error');
      }
    }
  };

  // useEffect(() => {
  //   setFormData({
  //     email: auth0User?.email || '',
  //     firstName: auth0User?.given_name || auth0User?.nickname || '',
  //     lastName: auth0User?.family_name || '',
  //     auth0_id: auth0User?.sub || '',
  //   });
  // }, [auth0User]);

  const handleFormSubmit = (data) => {
    switch (step) {
      case 'profile':
        // setFormData({
        //   ...formData,
        //   ...data,
        // });
        // setStep('location');

        const payload = {
          ...formData,
          ...data,
        };
        setFormData(payload);
        submitApplication(payload);
        break;
      case 'location':
        // const payload = {
        //   ...formData,
        //   ...data,
        // };
        // setFormData(payload);
        // submitApplication(payload);
        // setStep('about');
        break;
      // case 'about': {
      //   const payload = {
      //     ...formData,
      //     ...data,
      //   };
      //   setFormData(payload);
      //   submitApplication(payload);
      //   break;
      // }
      default:
        break;
    }
  };

  const handleBack = (data) => {
    switch (step) {
      case 'location':
        setFormData({
          ...formData,
          ...data,
        });
        setStep('profile');
        break;
        // case 'about':
        //   setFormData({
        //     ...formData,
        //     ...data,
        //   });
        //   setStep('location');
        //   break;
        // default:
        break;
    }
  };

  if (step === 'profile') {
    return (
      <JoinFormProfileStep
        nonProfit={nonProfit}
        onSubmit={handleFormSubmit}
        formData={formData}
        handleFormData={handleFormData}
      />
    );
  }
  if (step === 'location') {
    return (
      <JoinFormLocationStep
        onSubmit={handleFormSubmit}
        onBack={handleBack}
        formData={formData}
        handleFormData={handleFormData}
      />
    );
  }
  // if (step === 'about') {
  //   return (
  //     <JoinFormFinalStep
  //       onSubmit={handleFormSubmit}
  //       onBack={handleBack}
  //       formData={formData}
  //       handleFormData={handleFormData}
  //     />
  //   );
  // }
  if (step === 'success') {
    return (
      <div className="flex w-full flex-1 flex-col gap-12">
        <Typography variant="h1" component="h2">
          Thank You!
        </Typography>
        <Typography variant="body1">
          {nonProfit?.company?.visibilityType === 'public'
            ? 'You have successfully joined the nonprofit community. Please check you email to find the login link.'
            : `Thank you for joining ${
                nonProfit?.company?.name || nonProfit?.name
              }! Your request is submitted and pending approval by the Nonprofit Admin. We'll notify you once it's approved.`}
        </Typography>
      </div>
    );
  }
  if (step === 'error') {
    return (
      <div className="flex w-full flex-1 flex-col gap-12">
        <Typography variant="h1" component="h2">
          Application Error
        </Typography>
        <Typography variant="body1">
          Your application has already been submitted. Please log in or check
          your email for further instructions.
        </Typography>
      </div>
    );
  }

  if (step === 'backend-error') {
    return (
      <div className="flex w-full flex-1 flex-col gap-12">
        <Typography variant="h1" component="h2">
          Oops... Something went wrong!
        </Typography>
        <Typography variant="body1">
          Please comeback and try again later or contact us at hello@neki.io;
        </Typography>
      </div>
    );
  }
  return null;
}

export default GuestJoinNonProfitForm;
